import extendNode from '../extendNode.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import meta from './metaFcRep.mjs'

export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,

        canMountType(map, node, type) {
            return /^(REP)$/.test(type)
        },

        menuItemsInsertConcept(map, node) {
            return [
                {type: 'REP'},
            ]
        },
    })
}
